/**
 * SOW content map (ADR-073 card-first / ADR-076) — staff fork.
 *
 * Mirrors content/bow.ts. The sow-complete bookend copy lives here, not inline,
 * so a future Flow-Composer copy override has a single target.
 */

export interface SowCompleteContent {
  heading: string;
  body: string;
  confirmCta: string;
  successHeading: string;
  successBody: string;
}

export const SOW_CONTENT: { complete: SowCompleteContent } = {
  complete: {
    heading: 'Create the subscriber account',
    body: 'This confirms the plan and creates the subscriber’s account and domain, then emails them an activation link to set their password. The trust snippet is emailed after they activate.',
    confirmCta: 'Create account & send activation',
    successHeading: 'Subscriber onboarded',
    successBody: 'The account has been created and an activation email is on its way. They set their password via the link, then the snippet email follows.',
  },
};
